import React from "react";
import { CalendarX2, MapPin, AlertTriangle } from "lucide-react";
import { TYPES, iso, addDays, prettyDay, timeRange, duration } from "./calUtils";

export function AgendaView({ cursor, byDate, onOpen }) {
  const today = iso(new Date());
  const days = Array.from({ length: 31 }, (_, i) => iso(addDays(cursor, i))).filter((d) => (byDate[d] || []).length);
  if (!days.length) {
    return (
      <div className="bg-white rounded-2xl border border-gray-100 p-10 text-center" data-testid="cal-agenda-empty">
        <CalendarX2 className="w-8 h-8 mx-auto text-muted-foreground" />
        <p className="font-head font-bold mt-2">Nothing scheduled in the next 30 days</p>
        <p className="text-sm text-muted-foreground">Try clearing filters or moving ahead.</p>
      </div>);
  }
  return (
    <div className="space-y-3" data-testid="cal-agenda-view">
      {days.map((d) => (
        <section key={d} className="bg-white rounded-2xl border border-gray-100 overflow-hidden" data-testid={`agenda-day-${d}`}>
          <h3 className={`px-4 py-2 text-xs font-bold uppercase tracking-wide border-b border-gray-100 ${d === today ? "bg-teal text-white" : "bg-background text-muted-foreground"}`}>
            {d === today ? "Today · " : ""}{prettyDay(d, { weekday: "long", month: "short", day: "numeric" })}
          </h3>
          <ul className="divide-y divide-gray-100">
            {byDate[d].map((it) => {
              const st = TYPES[it.type] || TYPES.event;
              const dur = duration(it.start_time, it.end_time);
              return (
                <li key={it.uid}>
                  <button type="button" data-testid={`agenda-item-${it.uid}`} onClick={() => onOpen(it)} className="w-full text-left px-4 py-3 flex gap-3 hover:bg-teal-light/30 transition-colors">
                    <div className="w-20 shrink-0 text-xs">
                      <p className="font-bold text-gray-800">{it.all_day ? "All day" : timeRange(it).split(" – ")[0]}</p>
                      {!it.all_day && it.end_time && <p className="text-muted-foreground">{timeRange(it).split(" – ")[1]}</p>}
                      {dur && <p className="text-muted-foreground">{dur}</p>}
                    </div>
                    <span className="w-1 rounded-full shrink-0" style={{ background: st.bg }} />
                    <div className="min-w-0 flex-1">
                      <p className="font-semibold text-sm text-gray-900 truncate">{it.title}{it.draft ? " (draft)" : ""}</p>
                      <p className="text-xs text-muted-foreground flex flex-wrap items-center gap-x-2">
                        <span style={{ color: st.bg }} className="font-semibold">{st.label}</span>
                        {it.location && <span className="flex items-center gap-0.5"><MapPin className="w-3 h-3" />{it.location}</span>}
                        {(it.teacher_names || []).length > 0 && <span>{it.teacher_names.join(", ")}</span>}
                        {it.span && <span>{it.span}</span>}
                      </p>
                      {(it.conflicts || []).length > 0 && <p className="text-xs text-red-600 font-semibold flex items-center gap-1 mt-0.5"><AlertTriangle className="w-3 h-3" />Scheduling conflict</p>}
                    </div>
                  </button>
                </li>);
            })}
          </ul>
        </section>))}
    </div>);
}
